import { memo, useCallback, useRef, useState } from "react";
import Avatar from "./Avatar";
import UserMenuList from "./UserMenuList";
import { useClickOutside } from "../layout/Sidebar";

const UserCardTablet = memo(() => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const close = useCallback(() => setOpen(false), []);
  const toggle = useCallback(() => setOpen(v => !v), []);
  useClickOutside(ref, close, open);

  return (
    <div ref={ref} className="relative flex justify-center">
      <div
        aria-hidden={!open}
        className={`
          absolute left-[calc(100%+10px)] bottom-0 w-55 z-50
          rounded-xl overflow-hidden border border-white/10
          shadow-[8px_8px_40px_rgba(0,0,0,0.45)]
          transition-[opacity,transform] duration-280
          ${open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
        `}
        style={{
          background: '#1e293b',
          transform: open ? 'translateX(0) scale(1)' : 'translateX(-8px) scale(0.96)',
          transitionTimingFunction: 'cubic-bezier(0.34,1.56,0.64,1)',
        }}
      >
        <div
          aria-hidden
          className="absolute -left-1.25 bottom-3.5 w-2.5 h-2.5 bg-[#1e293b] rotate-45 border-l border-b border-white/10"
        />
        <div className="flex items-center gap-2.5 px-3.5 py-3 border-b border-white/10">
          <Avatar size="sm" />
          <div className="min-w-0">
            <p className="text-white text-[13px] font-semibold truncate">Alex Sterling</p>
            <p className="text-slate-500 text-[10px] truncate">alex.sterling@agarmart.com</p>
          </div>
        </div>
        <UserMenuList open={open} compact />
      </div>

      <button
        type="button"
        aria-expanded={open}
        aria-haspopup="menu"
        aria-label="User menu"
        onClick={toggle}
        className={`
          w-10 h-10 rounded-xl flex items-center justify-center
          text-white text-sm font-bold select-none
          transition-all duration-200 cursor-pointer
          ${open
            ? 'bg-blue-500 ring-2 ring-blue-400 ring-offset-2 ring-offset-[#0f1f4b]'
            : 'bg-white/10 hover:bg-white/20'}
        `}
      >
        AS
      </button>
    </div>
  );
});

export default UserCardTablet;